const data = {
  title: "Floor 1-6",
  musicTrack: "MUSIC_WORLD1",
  theme: "BLUE",
  tilesWidth: 11,
  tilesHeight: 5,
  placements: [
    {
      type: "HERO_SPAWN",
      x: 2,
      y: 4,
    },
    {
      type: "PLACEMENT_TYPE_GOAL",
      x: 10,
      y: 2,
    },
    {
      type: "KEY",
      x: 2,
      y: 2,
      color: "GREEN",
    },
    {
      type: "WALL",
      x: 8,
      y: 1,
    },
    {
      type: "WALL",
      x: 8,
      y: 2,
    },
    {
      type: "WALL",
      x: 8,
      y: 3,
    },
    {
      type: "WALL",
      x: 8,
      y: 4,
    },
    {
      type: "LOCK",
      x: 4,
      y: 5,
      color: "GREEN",
    },
    {
      type: "LOCK",
      x: 8,
      y: 5,
      color: "BLUE",
    },
    {
      type: "THIEF",
      x: 6,
      y: 4,
    },
    {
      type: "THIEF",
      x: 6,
      y: 2,
    },
    {
      type: "LOCK",
      x: 4,
      y: 1,
      color: "GREEN",
    },
    {
      type: "LOCK",
      x: 4,
      y: 3,
      color: "BLUE",
    },
    {
      type: "WALL",
      x: 5,
      y: 2,
    },
    {
      type: "WALL",
      x: 7,
      y: 2,
    },
    {
      type: "WALL",
      x: 5,
      y: 4,
    },
    {
      type: "WALL",
      x: 7,
      y: 4,
    },
    {
      type: "CHIP",
      x: 7,
      y: 5,
    },
    {
      type: "CHIP",
      x: 7,
      y: 1,
    },
    {
      type: "CHIP",
      x: 7,
      y: 3,
    },
    {
      type: "KEY",
      x: 5,
      y: 3,
      color: "BLUE",
    },
    {
      type: "WALL",
      x: 4,
      y: 2,
    },
    {
      type: "WALL",
      x: 4,
      y: 4,
    },
  ],
};

export default data;
